import TaxForm from "@/components/TaxBureauStep/TaxForm";
import { inject, observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import RenderQRcode from "./RenderQRcode";
import styles from "./index.less";
import { Button, Spin } from "antd";
import { useRequest } from "ahooks";

const setpFormConfig = ["taxDeclareProvince", "companyName"];

const getQRCode = async (type, params) => {
  return {
    qrcode: '测试二维码，请忽略'
  }
};

const APP_LIST = [
  { label: "电子税务局APP", value: "ENTERPRISE" },
  // { label: "个人所得税APP", value: "PERSONAL" },
];

const QRCodeTab = ({ taxHelperStore, onFinishAuth }) => {
  /** 表单区域引用 */
  const [taxFormRef] = useState(React.createRef());
  const [type, setType] = useState(APP_LIST[0].value);

  const { province, serialNo, nsrsbh } = taxHelperStore.authQueryParams;

  const { data, loading, refresh } = useRequest(
    () =>
      getQRCode(type, {
        serialNo,
        creditCode: nsrsbh,
        area: province,
      }),
    {
      refreshDeps: [type, province],
    }
  );
  

  /** 表单实例 */
  const formInstances = () => {
    return taxFormRef.current.formRef.current;
  };

  /**
   * 自动填入授权省份，企业名称
   */
  useEffect(() => {
    const { qymc, province } = taxHelperStore.authQueryParams;
    formInstances().setFieldsValue({
      companyName: qymc,
      taxDeclareProvince: province,
    });
  }, [taxHelperStore.authQueryParams]);

  return (
    <div>
      <TaxForm
        formStep="first"
        ref={taxFormRef}
        setpFormConfig={setpFormConfig}
        formInstances={formInstances}
        NEW_AUTH
      />
      <div className={styles.qrcodeContent}>
        <p className={styles.title}>
          打开<span>{APP_LIST.find((item) => item.value === type)?.label}</span>扫一扫
        </p>
        <Spin spinning={loading} tip="二维码加载中...">
          <div className={styles.qrcodeBox}>
            {
              !loading && (
                <RenderQRcode type={type} data={data}/>
              )
            }
            {/* 蒙城 */}
            <div className={styles.mask}>
              <div>
              测试二维码
              </div>
            </div>
          </div>
        </Spin>
        <p className={styles.tip}>截图后，2分钟内用对应APP完成扫码</p>
        <div className={styles.appList}>
          {APP_LIST.map((item) => {
            return (
              <Button
                shape="round"
                key={item.value}
                type={item.value === type ? "primary" : "default"}
                onClick={() => setType(item.value)}
              >
                {item.label}
              </Button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default inject(
  "taxHelperStore",
  "taxAuthStore"
  // 'provinceStore'
)(observer(QRCodeTab));

// export default QRCodeTab;
